import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e27c013"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "stats" }
const _hoisted_2 = { class: "stats-inner" }
const _hoisted_3 = { class: "cards" }
const _hoisted_4 = { class: "card" }
const _hoisted_5 = { class: "card-title" }
const _hoisted_6 = { class: "line" }
const _hoisted_7 = { class: "line" }
const _hoisted_8 = { class: "line" }
const _hoisted_9 = { class: "card" }
const _hoisted_10 = { class: "card-title" }
const _hoisted_11 = { class: "line" }
const _hoisted_12 = { class: "line" }
const _hoisted_13 = { class: "line" }
const _hoisted_14 = { class: "foot" }
const _hoisted_15 = { class: "note" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", null, _toDisplayString(_ctx.$t('home.statistics.title')), 1),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('home.statistics.cards.effect.title')), 1),
          _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t('home.statistics.cards.effect.rate')), 1),
          _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t('home.statistics.cards.effect.retention')), 1),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('home.statistics.cards.effect.drop')), 1)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t('home.statistics.cards.global.title')), 1),
          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('home.statistics.cards.global.users')), 1),
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('home.statistics.cards.global.hours')), 1),
          _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('home.statistics.cards.global.workouts')), 1)
        ])
      ]),
      _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.$t('home.statistics.foot')), 1),
      _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t('home.statistics.note')), 1)
    ])
  ]))
}